/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

window.sbBehaviours = window.sbBehaviours || {};
sbBehaviours.billCommonFunctions = {
    properties: {
        typeOfBiller: {
            type: Object,
            value: {
                RegisterdBiller: 1,
                UnregisteredBiller: 2
            }
        }
    },
    _getHeaderColor: function (billerDetails) {
        var billCategoryType;
        if (typeof billerDetails == "object")
            billCategoryType = billerDetails.category ? billerDetails.category.codeDescription : null;
        else
            billCategoryType = billerDetails;
        if (billCategoryType === "Utilities") {
            return "bill-category-header-utilities";
        } else if (billCategoryType === "Telephone") {
            return "bill-category-header-telephone";
        } else if (billCategoryType === "Other") {
            return "bill-category-header-other";
        } else {
            return "bill-category-header-default";
        }
    },
    _getMenuBorderColor: function (billCategoryType) {
        if (billCategoryType === "Utilities") {
            return "bill-category-menu-border-utilities";
        } else if (billCategoryType === "Telephone") {
            return "bill-category-menu-border-telephone";
        } else if (billCategoryType === "Other") {
            return "bill-category-menu-border-other";
        } else {
            return "bill-category-menu-border-default";
        }
    },
    // to open the auto pay page
    _openAutopay: function (event) {
        var self = this;
        self.set("billerAutoPayLanding", true);
        // this._closeMenu(e);
        if (!this.registrationId)
            this.billerSelected(event.model.item.billerNickName);
        setTimeout(function () {
            self.shadowRoot.querySelector("#autopayelemdia").$$("#autopayelem").open();
            self.shadowRoot.querySelector("biller-auto-pay-landing").$$("biller-auto-pay")._setDefaults();
        }, 1000);
        this.autoPayMode=undefined;
        this.limitAmount = this.autopayLimitMinAmount;
    },
    // to open the stop bill payment and fire the ajax call in that page  
    _openStopBill: function (event) {
        var billerId = this.registrationId ? this.registrationId : event.model.item.billerId;
        this._getBillerDetails(billerId, event);
    },
    _proceedStopBill: function (event, response) {
        var self = this;
        self.set("stopBill", true);
         //for RECON defect 338461
    if(!_.isUndefined(response))
    {
      var subscriptionDetails = response.subscriptionDetails;
    }
    if (!self.parsedBill) {
      self.selectedScheduleBill = event.model.item;
      self.billerSelected(event.model.item.billerNickName,subscriptionDetails);
    }

        setTimeout(function () {
            self.shadowRoot.querySelector("#stopbillelemdia").$$("#stopbillelem").open();
            self.shadowRoot.querySelector("stop-bill").firebillerInstanceRequest();
        }, 1000);

    },
    _getBillerDetails: function (tempBillerId, eventData) {
        var self = this;
        self.userId = clientStorage.get(storageType.session, 'userId');
        var ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = '/api/CBUsers/' + self.userId + '/billers/' + tempBillerId;
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function () {
			//Recon Defect fix for 338461
           // self._proceedStopBill(eventData);
		   var res = event.detail.response;
		   self._proceedStopBill(eventData,res);

        });
        ajaxCall.addEventListener('error', function (event) {
            var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
            var headers = convertedArr.reduce(function (each, current) {
                var parts = [current.split(": ", 1).toString(), current.split(": ").slice(
                    1).join(": ")];
                each[parts[0]] = parts[1];
                return each;
            }, {});
            if (headers.channelcontext) {
                self.fire('oe-show-error', JSON.parse(headers.channelcontext).status.message[0].messageDesc);
            } else
                self.fire('oe-show-error', event.detail.error.message);
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();
    },
    // to open the modify scheduled bill payment
    _openModifyBill: function (event) {
        // this._closeMenu(e);
        this.selectedScheduleBill = event.model.item;
        this.billerSelected(event.model.item.billerNickName);
        if (this.selectedBiller && this.selectedBiller.registrationId) {
            window.oe_navigate_to('/billPayment-new', {
                "isRegisteredBiller": true,
                "billId": event.model.item.billId,
                "billType": event.model.item.upcomingBillType,
        "registrationId": this.selectedBiller.registrationId,
        "billTypeInfo":event.model.item.billType
            });
        } else {
            if (this._getBillerDetails(event.model.item.billerId)) {
                window.oe_navigate_to('/billPayment-new', {
                    "isRegisteredBiller": false,
                    "billId": event.model.item.billId,
                    "billType": event.model.item.upcomingBillType,
          "billerId": event.model.item.billerId,
          "billTypeInfo":event.model.item.billType
                });
            }
        }

    },
    //Add a listener on iron-overlay for this
    _openNextDialog: function () {
        var self = this;
        if (this.isAutoPayAuthDialog) {
            self.isAutoPayAuthDialog = false;
            self.set("billerAutoPayAuth", true);
            setTimeout(function () {
                self.shadowRoot.querySelector("#authorizeelemdia").$$("#authorizeelem").open();
            }, 1000);
        } else if (this.isAutoPaySuccessDialog) {
            this.isAutoPaySuccessDialog = false;
            self.set("billerAutoPaySuccess", true);
            setTimeout(function () {
                self.shadowRoot.querySelector("#successelemdia").$$("#successelem").open();
            }, 1000);
        } else if (this.isStopAuthDialog) {
            this.isStopAuthDialog = false;
            self.set("stopBillAuth", true);
            setTimeout(function () {
                self.shadowRoot.querySelector("#stopbillauthorizeelemdia").$$("#stopbillauthorizeelem").open();
            }, 1000);
        }
    },
    _hideLastborderinList: function (list, index) {
        var totallength = list.length;
        if (totallength == 1)
            return true;

        var lastelement = totallength - 1;
        if (lastelement === index)
            return true;
        else
            return false;


    },
    trimspace: function (formatstring) {
        var format = typeof (formatstring);
        var desc;
        if (format === 'string') {
            desc = formatstring;
        } else {
            desc = formatstring.codeDescription;
        }
        return desc.replace(/\s/g, '');
    },
    _ifBillTypeIsDue: function (billType) {
        this.dueBillTypeString = getLabel("l_Due");
        if (billType && billType === this.dueBillTypeString)
            return true;
        return false;
    },

    _ifBillTypeIsScheduled: function (billType) {
        this.scheduledBillTypeString = getLabel("l_Scheduled");
        if (billType && billType === this.scheduledBillTypeString)
            return true;
        return false;
    },
    getScriptionValueAsString: function (selectedBiller) {
        var subcriptionDetails = selectedBiller.subscriptionDetails;
        var subscriDetailLength = subcriptionDetails.length;
        var subscriString = "";
        if (subscriDetailLength > 1) {
            for (var i = 0; i < subscriDetailLength; i++) {
                subscriString += subcriptionDetails[i].subscriptionValue;

                if (subcriptionDetails[i].subscriptionValue != "" && i < subscriDetailLength - 1)
                    subscriString += "|";
            }
        } else {
            subscriString = subcriptionDetails[0].subscriptionValue;
        }

        return subscriString;
    },
    dateTimeConversion: function (transactionDate) {
        return moment(getNewdate(transactionDate)).format("ddd D MMM YYYY, h:mm A");
    },
    getTodayTransactionTime: function () {
        var tranDate = getNewDate();
        return moment(tranDate).format("ddd D MMM YYYY, h:mm A");

    },
    dateConversion: function (transactionDate) {
        return moment(getNewDate(transactionDate)).format("ddd D MMM YYYY");
    },
    monthLocaleTransform: function (date) {
        return getNewDate(date).toLocaleString(clientStorage.get(storageType.session, 'lang'), {
            month: "short"
        });
    },
    _hidefirstborderinList: function (index) {
        if (this.phone && index === 0)
            return true;
        else if ((this.desktop || this.tablet) && index === 0)
            return true;
        else if ((this.desktop || this.tablet) && index === 1)
            return true;
        else
            return false;
    },
    _showError: function (event) {
        //Headers is obtained as a single string and JSON.stringify will stringify the whole string hence broken down
        var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
        var headers = convertedArr.reduce(function (each, current) {
            var parts = current.split(': ');
            each[parts[0]] = parts[1];
            return each;
        }, {});
        if (headers.channelcontext) {
            var chnlctx = JSON.parse(headers.channelcontext);
            if (_.get(chnlctx, 'status.message[0].messageCode') !== '8504') {
                this.fire('oe-show-error', _.get(chnlctx, 'status.message[0].messageDesc'));
            }
        } else
            this.fire('oe-show-error', event.detail.error.message);
    },
    getSymbolizedAmount: function (curren, amount) {
        return currency.symbolize(curren + ' ' + amount);
    },
    dateParse: function (d) {
        return d.toISOString().slice(0, 19);
    },
    symbolizeCurrency: function (amount, curr) {
        return currency.symbolize(curr + " " + amount);
    },
    //Extract Hours as per UX
    extractHour: function (datetime) {
        var d = getNewDate(datetime);
        return d.getHours() + ":" + d.getMinutes();
    },
    transactionTypeCheck: function () {
        var date = getNewDate();
        if (this.recurringCheckbox && this.recurringDate <= date) {
            this.fire('oe-show-error', {
                code: 'm_SelectFutureDate',
                message: getLabel('m_SelectFutureDate')
            });
            return false;
        }

        if (this.frequencyIndex != 0) {
            this.frequencytype = 'R';
            if (this.frequencyIndex == 7) {
                if (!this.numberOfDays) {
                    this.fire('oe-show-error', {
                        code: 'm_EnterNumberOfDays',
                        message: getLabel('m_EnterNumberOfDays')
                    });
                    return false;
                }
            } else if (this.numberOfDays != 0) {
                this.numberOfDays = 0;
            }

      if (!this.numberOfInstallments || this.numberOfInstallments < 2) {
        this.fire('oe-show-error', {
          code: 'm_EnterInstallments',
          message: getLabel('m_EnterInstallments')
        });
        return false;
      }
    }

    return true;
  },
  // Function for the ordering of the cocd values based on sequence
  reorderCOCDforUI: function (sequence, data) {
    var count = 0;
    var mData = [];
    for (var i = 0; i < sequence.length; i++) {
      for (var j = 0; j < data.length; j++) {
        if (sequence[i] == data[j].cmCode) {
          mData[count] = data[j];
          count++;
          break;
        }
      }
    }
    return mData;
  }

};